/**
 * Dependencies.
 */
import { createElement as el } from "@wordpress/element";
import AppConfig from "../../services/appConfig";
import "./languageList.css";

/*
interface ListProps {
  open?: boolean;
  className?: string;
  children?: any;
}
// */

interface AssocArray {
  [key: string]: string;
}

/**
 * Provides a LanguageList.
 *
 * @return {element} LanguageList.
 */
const LanguageList = () => {
  const config = AppConfig();

  const getEnabledLanguages = () => {
    return config.enabledLanguages;
  };

  const getLanguageOptionIconEl = (language: string) => {
    let iconURL = config.optionIcon[language];
    let className = "language-option-icon";
    let title =
      config.enLanguageName[language] +
      " has options: sidebars_widgets, widget_*";

    if (iconURL === "") {
      title = "";
      iconURL = config.optionIcon[config.defaultLanguage];
      className = className + " visibility-hidden";
    }
    return el("img", { className: className, src: iconURL, title: title });
  };

  const getLanguageList = () => {
    const href = config.href;
    const flagUrl = config.languageFlagUrl;
    var sign = "&";
    var refs: AssocArray = {};

    if (-1 === href.indexOf(config.pagenow + "?")) {
      sign = "?";
    }

    for (var key in config.enabledLanguages) {
      if (-1 === href.indexOf("language=" + config.currentLanguage)) {
        refs[config.enabledLanguages[key]] =
          href + sign + "language=" + config.enabledLanguages[key];
      } else {
        refs[config.enabledLanguages[key]] = href.replace(
          "language=" + config.currentLanguage,
          "language=" + config.enabledLanguages[key]
        );
      }
    }
    // el('a', {href:refs[lang], isSmall:true, isPrimary:true, className:'components-button is-primary is-small'}, config.enLanguageName[lang])
    return el(
      "ul",
      { className: "language-list" },
      getEnabledLanguages().map(function (language: string) {
        return el(
          "li",
          { key: language, className: "language-item" },
          getLanguageOptionIconEl(language),
          el("img", {
            className: "language-flag",
            height: "20",
            width: "20",
            src: flagUrl[language],
          }),
          el(
            "a",
            {
              href: refs[language],
              className: "components-button is-primary is-small",
            },
            config.enLanguageName[language]
          )
        );
      })
    );
  };

  return getLanguageList();
};

export default LanguageList;
